<template>
  <v-btn
    exact
    outlined
    :color="color"
    :block="$mq | mq({ xs: true, md: false })"
    class="mb-4"
    v-bind="{ ...$attrs, ...$props }"
    ><v-icon small left>mdi-arrow-left</v-icon>{{ title }}</v-btn
  >
</template>

<script>
export default {
  name: 'BtnBack',
  components: {},
  props: {
    title: {
      type: String,
      default: 'Back',
    },
    color: {
      type: String,
      default: 'blue darken-2',
    },
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped></style>
